import { render, staticRenderFns } from "./contact-qr.vue?vue&type=template&id=43b938db&scoped=true&"
import script from "./contact-qr.vue?vue&type=script&lang=js&"
export * from "./contact-qr.vue?vue&type=script&lang=js&"
import style0 from "./contact-qr.vue?vue&type=style&index=0&id=43b938db&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b938db",
  null
  
)

export default component.exports